import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { BoxV2 } from '@labrav/react-components'
import { useStyles } from './FlyOutDimensionWrapper.styles'
import { faShelves } from '@fortawesome/pro-regular-svg-icons'
import { Typography } from '@mui/material'

interface DimensionsSectionBoxProps {
  heading: string
  sectionText: string
  children: JSX.Element
  secondaryActions: JSX.Element
}

export const FlyOutDimensionWrapper = ({
  heading,
  sectionText,
  children,
  secondaryActions,
}: DimensionsSectionBoxProps) => {
  const { classes } = useStyles()

  return (
    <BoxV2
      heading={heading}
      headingIcon={
        <FontAwesomeIcon
          icon={faShelves}
          style={{ width: '18px', height: '14px' }}
        />
      }
      secondaryActions={secondaryActions}
    >
      <div className={classes.textContainer} data-testid="text-container">
        <Typography className={classes.sectionText}>{sectionText}</Typography>
      </div>
      {children}
    </BoxV2>
  )
}
